module.exports = "/_next/static/images/HeroImage@2x-50118a2641c4a14595d5f76e03db9664.webp";